.page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}
